<template>
  <v-card class="mb-4">
    <v-card-title>
      Champ non défini
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <field-type v-model="typeId" />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn fab dark x-small color="red">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import FieldType from "../../helpers/FieldType";
export default {
  name: "undefined-field",
  components: {
    FieldType
  },
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    typeId: null
  }),
  watch: {
    typeId: function() {
      this.chooseType();
    }
  },
  methods: {
    async chooseType() {
      await axios
        .post(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.block.id +
            "/field",
          {
            type_id: this.typeId
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
            }
          }
        )
        .then(
          function(response) {
            if (response.status === 200) {
              this.$emit("refresh");
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    }
  }
};
</script>